<template>
  <div class="stepperParent">
     <div class="eachStep">
      <transition name="stepper-fade" mode="out-in">
        <div v-if="currentStep < 1" class="eachCircleContainer"  key="step1-num">
          <div class="eachCircle body-medium-16-regular">1</div>
        </div>
        <div
          v-else
          :class="!$vuetify.rtl && 'eachCircleContainerLtr'"
          class="eachCircleContainer eachCircleContainerPassed"
          key="step1-check"
        >
          <img
            src="./../../assets/newPreSession/successCheck.png"
            alt=""
            class="checkImage"
          />
        </div>
      </transition>
      <div class="eachCircleText body-medium-16-regular" :class="!$vuetify.rtl && 'eachCircleTextLtr'">{{$t('newPreSession.step1')}}</div>
      <div class="stepperLineContainer">
        <div v-if="currentStep < 1" class="stepperLine"></div>
        <div v-else class="stepperLine stepperLinePassed"></div>
      </div>
    </div>
    <!-- Step 2 -->
    <div class="eachStep">
      <transition name="stepper-fade" mode="out-in">
        <div v-if="currentStep < 2" class="eachCircleContainer"

             key="step2-num">
          <div class="eachCircle body-medium-16-regular">2</div>
        </div>
        <div
          v-else
          :class="!$vuetify.rtl && 'eachCircleContainerLtr'"
          class="eachCircleContainer eachCircleContainerPassed"
          key="step2-check"
        >
          <img
            src="./../../assets/newPreSession/successCheck.png"
            alt=""
            class="checkImage"
          />
        </div>
      </transition>
      <div class="eachCircleText body-medium-16-regular" :class="!$vuetify.rtl && 'eachCircleTextLtr'">{{ $t('newPreSession.step2') }}</div>

      <div class="stepperLineContainer">
        <transition name="line-fade" mode="out-in">
          <div
            :class="{
              stepperLine: currentStep < 2 && $vuetify.rtl,
              stepperLineEn: currentStep < 2 && !$vuetify.rtl,
              stepperLinePassed: currentStep >= 2,
            }"
            :key="currentStep < 2 ? 'not-passed' : 'passed'"
          ></div>
        </transition>
      </div>
    </div>
    <!-- Step 3 -->
    <div class="eachStep">
      <transition name="stepper-fade" mode="out-in">
        <div
          v-if="currentStep === 3 || currentStep === 2"
          class="eachCircleContainer"
          :class="{ activeStep: currentStep === 2,eachCircleContainerLtr : !$vuetify.rtl }"
          key="step3-num"
        >
          <div class="eachCircle body-medium-16-regular">3</div>
        </div>

        <div
          v-else
          class="eachCircleContainer eachCircleContainerDeActive"
          key="step3-inactive body-medium-16-regular"
        >
          <div class=" body-medium-16-regular">3</div>

        </div>
      </transition>

      <div class="eachCircleText body-medium-16-regular">{{ $t('newPreSession.step3') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentStep: {
      type: Number,
    },
  },
};
</script>

<style scoped>
@media (min-width: 700px) and (max-width: 1000px) {
  .stepperLine {
    width: 100px !important;
  }
  .stepperLineContainer {
    width: 100px !important;
  }
}

@media (min-width: 350px) and (max-width: 700px) {
  .stepperLine {
    width: 70px !important;
  }
  .stepperLineContainer {
    width: 70px !important;
  }
}

.eachCircleContainer {
  width: 34px;
  height: 34px;
  border-radius: 34px;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #d7f4e9;
  margin-right: 8px;
}

.eachCircleContainerDeActive {
  background-color: white;
  border: 2px solid #e1e1e1;
}

.eachCircleContainerPassed {
  background-color: #39c990;
  display: flex;
  align-items: center;
  justify-content: center;
}
.eachCircle {
  color: #39c990;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #39c990;
}

.eachCircleText {
  margin: 4px 4px 4px 8px;
}
.stepperLine {
  width: 200px;
  height: 4px;
  border-radius: 4px;
  background: linear-gradient(to left, #39c990 0%, #e1e1e1 50%);
}

.stepperLineEn {
  width: 200px;
  height: 4px;
  border-radius: 4px;
  background: linear-gradient(to right, #39c990 0, #e1e1e1 50%);
}

.stepperLinePassed {
  background: linear-gradient(to left, #39c990 0%, #39c990 100%);
}

.stepperLineContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 32px;
}

.stepperParent {
  align-self: center;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.eachStep {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.checkImage {
  width: 15px;
  height: 10px;
}

.stepper-fade-enter-active,
.stepper-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.stepper-fade-enter,
.stepper-fade-leave-to {
  opacity: 0;
  transform: scale(0.7) rotate(-10deg);
}

.stepperLine,
.stepperLinePassed {
  width: 200px;
  height: 4px;
  border-radius: 4px;
  transition: background 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.stepperLine {
  background: linear-gradient(to left, #39c990 0%, #e1e1e1 50%);
}

.stepperLinePassed {
  background: linear-gradient(to left, #39c990 0%, #39c990 100%);
}

.line-fade-enter-active,
.line-fade-leave-active {
  transition: opacity 0.25s;
}
.line-fade-enter,
.line-fade-leave-to {
  opacity: 0;
}
.eachCircleTextLtr {
  margin-right: 15px !important;

}
</style>
